import { createSlice } from '@reduxjs/toolkit';
import { getSettings, setSettings, NavigationSettings } from '../common/Settings';
import { getAuthData } from '../services/AuthService';

//If we're not logged in, then the userId will be null and therefore 0 will be used, this will result in no settings being found and therefore using the defaults
//If a user is logged in though, then it will automatically read the token data properly and know the userId and therefore use their settings
let userId = getAuthData()?.userId ?? 0;
let settings = getSettings("SideNavBarSlice", userId) as NavigationSettings ?? {
    configType: "SideNavBarSlice",
    userId: userId,
    darkMode: false,
    debugMode: false,
    isSideMenuOpen: false,
    isDrawerWider: false
};

//Navigation hook slice something something... I don't understand these terms
const SideNavBarSlice = createSlice({
    name: 'SideNavBarSlice',
    initialState: {
        isSideMenuOpen: settings.isSideMenuOpen ,
        darkMode: settings.darkMode,
        debugMode: settings.debugMode,
        isDrawerWider: settings.isDrawerWider
    },
    reducers: {
        toggleSideMenu: state => {
            state.isSideMenuOpen = !state.isSideMenuOpen;
            settings.isSideMenuOpen = !settings.isSideMenuOpen;
            setSettings(settings);
        },
        changeTheme: state => {
            state.darkMode = !state.darkMode;
            settings.darkMode = state.darkMode;
            setSettings(settings);
        },
        setDebug: state => {
            state.debugMode = !state.debugMode
            settings.debugMode = state.debugMode;
            setSettings(settings);
        },
        setWiderDrawer: state => {
            state.isDrawerWider = !state.isDrawerWider;
            settings.isDrawerWider = !settings.isDrawerWider;
            setSettings(settings);
        }
    }
})

export const { toggleSideMenu, changeTheme, setDebug, setWiderDrawer } = SideNavBarSlice.actions

export default SideNavBarSlice;
